/* istanbul ignore file */
import React from 'react';
import { Button } from 'framework/ui/mui-builder';
import { useSubmit } from 'framework/utils';
import { useVacancyGroupService } from 'domain/shared/newVacancy';
import { useShowContext } from 'framework/show';

const DeclineVacancyCancellationRequestButton = ({
  setGeneralContextData,
  setModalOpen,
}: {
  setGeneralContextData: () => {};
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { declineVacancyCancellation } = useVacancyGroupService();

  const { data } = useShowContext();
  const { id } = data.getData();

  const { onSubmit } = useSubmit({
    submitMethod: () => declineVacancyCancellation(id!),
    afterSubmit: {
      successMessage: 'Vacancy cancellation request has been successfully declined.',
      errorMessage: "Can't decline cancellation request.",
      execute: () => {
        if (setGeneralContextData) {
          setGeneralContextData();
        }
      },
    },
  });

  return (
    <Button
      onClick={() => {
        onSubmit();
        setModalOpen(false);
      }}
      variant="outlined"
    >
      Decline
    </Button>
  );
};

export default DeclineVacancyCancellationRequestButton;
